export enum YOUTUBE_THUMBNAIL {
  DEFAULT = 'default.jpg',
  MEDIUM = 'mqdefault.jpg',
  HIGH = 'hqdefault.jpg',
  STANDARD = 'sddefault.jpg',
  MAXRES = 'maxresdefault.jpg',
}

export enum GALLERY_MEDIA_TYPE {
  VIDEO = 'VIDEO',
  IMAGES = 'IMAGES',
  IMAGE_360 = 'IMAGE_360',
}

export interface MainContent {
  content: any;
  type: GALLERY_MEDIA_TYPE;
}
